import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/constants";

const Testimonials = () => {
  return (
    <section id="stimmen" data-testid="testimonials-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#1FA3B5] mb-4">Kundenstimmen</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
            Was unsere Kunden über uns sagen.
          </h2>
        </motion.div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#F8FAFC] rounded-3xl p-8 lg:p-10 border border-slate-100 hover:border-[#1FA3B5]/30 hover:bg-white hover:shadow-xl transition-all"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#1FA3B5]/15" />
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#FFB400] text-[#FFB400]" />
                ))}
              </div>
              <blockquote className="text-slate-700 leading-relaxed text-base">"{t.text}"</blockquote>
              <figcaption className="mt-6 pt-6 border-t border-slate-200">
                <p className="font-heading font-semibold text-slate-900">{t.name}</p>
                <p className="text-sm text-slate-500 mt-0.5">{t.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
